import { render, staticRenderFns } from "./SkinsplusBuyDialog.vue?vue&type=template&id=5e0dba3a&"
import script from "./SkinsplusBuyDialog.vue?vue&type=script&lang=ts&"
export * from "./SkinsplusBuyDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SkinsplusBuyDialog.vue?vue&type=style&index=0&id=5e0dba3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QCardSection,QSpace,QBtn,QLinearProgress});qInstall(component, 'directives', {ClosePopup});
